var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center"},[_c('h1',{staticClass:"error_title"},[_vm._v(" An error occurred! ")]),(_vm.error)?_c('p',{staticClass:"error_text"},[_vm._v(" "+_vm._s(_vm.error)+" ")]):_vm._e(),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.navBack}},[_vm._v(" Prøv på nytt ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }